// src/screens/registry.js
import { lazyNamed } from './lazyNamed';

// [keyRedux, NamedExport, PathSinExtension]
const defs = [
    ['uiOpenDashboard', 'Dashboard', 'components/ui/Dashboard'],

    ['uiOpenListDevice', 'ListDeviceScreen', 'components/ui/ListDeviceScreen'],

    ['uiOpenListUser', 'ListUserScreen', 'components/ui/ListUserScreen'],
    ['uiOpenAddUser', 'AddUserScreen', 'components/ui/AddUserScreen'],
    ['uiOpenEditUser', 'AddUserScreen', 'components/ui/AddUserScreen'],

    ['uiOpenListUserGroup', 'ListUserGroup', 'components/ui/ListUserGroup'],
    ['uiOpenAddUserGroup', 'AddUserGroup', 'components/ui/AddUserGroup'],
    ['uiOpenEditUserGroup', 'AddUserGroup', 'components/ui/AddUserGroup'],
    ['uiOpenAssociateUserGroupUser', 'AssociateUserGroupUser', 'components/ui/AssociateUserGroupUser'],
    ['uiOpenAssociateUserGroupDevice', 'AssociateUserGroupDevice', 'components/ui/AssociateUserGroupDevice'],

    ['uiOpenListDelivery', 'ListDeliveryScreen', 'components/ui/ListDeliveryScreen'],
    ['uiOpenAddDelivery', 'AddDeliveryScreen', 'components/ui/AddDeliveryScreen'],
    ['uiOpenEditDelivery', 'AddDeliveryScreen', 'components/ui/AddDeliveryScreen'],

    ['uiOpenListDeliveryRouteGroup', 'ListDeliveryGroup', 'components/ui/ListDeliveryGroup'],
    ['uiOpenAddDeliveryRouteGroup', 'AddDeliveryGroup', 'components/ui/AddDeliveryGroup'],
    ['uiOpenEditDeliveryRouteGroup', 'AddDeliveryGroup', 'components/ui/AddDeliveryGroup'],
    ['uiOpenAssociateDeliveryRouteGroupDelivery', 'AssociateDeliveryGroupDeliveryScreen', 'components/ui/AssociateDeliveryGroupDeliveryScreen'],
    ['uiOpenAssociateDeliveryRouteGroupDevice', 'AssociateDeliveryGroupDeviceScreen', 'components/ui/AssociateDeliveryGroupDeviceScreen'],

    ['uiOpenListCustomer', 'ListCustomerScreen', 'components/ui/ListCustomerScreen'],
    ['uiOpenAddCustomer', 'AddCustomerScreen', 'components/ui/AddCustomerScreen'],
    ['uiOpenEditCustomer', 'AddCustomerScreen', 'components/ui/AddCustomerScreen'],

    ['uiOpenListCustomerGroup', 'ListCustomerGroup', 'components/ui/ListCustomerGroup'],
    ['uiOpenAddCustomerGroup', 'AddCustomerGroup', 'components/ui/AddCustomerGroup'],
    ['uiOpenEditCustomerGroup', 'AddCustomerGroup', 'components/ui/AddCustomerGroup'],
    ['uiOpenAssociateCustomerGroupCustomer', 'AssociateCustomerGroupCustomerScreen', 'components/ui/AssociateCustomerGroupCustomerScreen'],
    ['uiOpenAssociateCustomerGroupDevice', 'AssociateCustomerGroupDeviceScreen', 'components/ui/AssociateCustomerGroupDeviceScreen'],

    ['uiOpenListDocument', 'ListDocumentScreen', 'components/ui/ListDocumentScreen'],
    // OJO con el path en minúsculas si tu archivo es así:
    ['uiOpenDocumentDetails', 'ListDocumentDetails', 'components/ui/listDocumentDetails'],

    ['uiOpenListNCFRange', 'ListNCFRangeScreen', 'components/ui/ListNCFRangeScreen'],
    ['uiOpenAddNCFRange', 'AddNCFRangeScreen', 'components/ui/AddNCFRangeScreen'],
    ['uiOpenEditNCFRange', 'AddNCFRangeScreen', 'components/ui/AddNCFRangeScreen'],

    ['uiOpenListNCFRangeGroup', 'ListNCFRangeGroup', 'components/ui/ListNCFRangeGroup'],
    ['uiOpenAddNCFRangeGroup', 'AddNCFRangeGroup', 'components/ui/AddNCFRangeGroup'],
    ['uiOpenEditNCFRangeGroup', 'AddNCFRangeGroup', 'components/ui/AddNCFRangeGroup'],
    ['uiOpenAssociateNCFRangeGroupNCFRange', 'AssociateNCFRangeGroupNCFRangeScreen', 'components/ui/AssociateNCFRangeGroupNCFRange'],
    ['uiOpenAssociateNCFRangeGroupDevice', 'AssociateNCFRangeGroupDeviceScreen', 'components/ui/AssociateNCFRangeGroupDevice'],

    ['uiOpenListPaymentMethod', 'ListPaymentMethodScreen', 'components/ui/ListPaymentMethodScreen'],
    ['uiOpenAddPaymentMethod', 'AddPaymentMethodScreen', 'components/ui/AddPaymentMethodScreen'],
    ['uiOpenEditPaymentMethod', 'AddPaymentMethodScreen', 'components/ui/AddPaymentMethodScreen'],

    ['uiOpenListPaymentMethodGroup', 'ListPaymentMethodGroup', 'components/ui/ListPaymentMethodGroup'],
    ['uiOpenAddPaymentMethodGroup', 'AddPaymentMethodGroup', 'components/ui/AddPaymentMethodGroup'],
    ['uiOpenEditPaymentMethodGroup', 'AddPaymentMethodGroup', 'components/ui/AddPaymentMethodGroup'],
    ['uiOpenAssociatePaymentMethodGroupPaymentMethod', 'AssociatePaymentMethodGroupPaymentMethodScreen', 'components/ui/AssociatePaymentMethodGroupPaymentMethodScreen'],
    ['uiOpenAssociatePaymentMethodGroupDevice', 'AssociatePaymentMethodGroupDeviceScreen', 'components/ui/AssociatePaymentMethodGroupDeviceScreen'],

    ['uiOpenListDiscount', 'ListDiscountScreen', 'components/ui/ListDiscountScreen'],
    ['uiOpenAddDiscount', 'AddDiscountScreen', 'components/ui/AddDiscountScreen'],
    ['uiOpenEditDiscount', 'AddDiscountScreen', 'components/ui/AddDiscountScreen'],

    ['uiOpenListProduct', 'ListProductScreen', 'components/ui/ListProductScreen'],
    ['uiOpenAddProduct', 'AddProductScreen', 'components/ui/AddProductScreen'],
    ['uiOpenEditProduct', 'AddProductScreen', 'components/ui/AddProductScreen'],

    ['uiOpenListProductGroup', 'ListProductGroup', 'components/ui/ListProductGroup'],
    ['uiOpenAddProductGroup', 'AddProductGroup', 'components/ui/AddProductGroup'],
    ['uiOpenEditProductGroup', 'AddProductGroup', 'components/ui/AddProductGroup'],
    ['uiOpenAssociateProductGroupProduct', 'AssociateProductGroupProduct', 'components/ui/AssociateProductGroupProduct'],
    ['uiOpenAssociateProductGroupDevice', 'AssociateProductGroupDevice', 'components/ui/AssociateProductGroupDevice'],

    ['uiOpenListPrice', 'ListPriceScreen', 'components/ui/ListPriceScreen'],
    ['uiOpenAddPrice', 'AddPriceScreen', 'components/ui/AddPriceScreen'],
    ['uiOpenEditPrice', 'AddPriceScreen', 'components/ui/AddPriceScreen'],

    ['uiOpenListTax', 'ListTaxScreen', 'components/ui/ListTaxScreen'],
    ['uiOpenAddTax', 'AddTaxScreen', 'components/ui/AddTaxScreen'],
    ['uiOpenEditTax', 'AddTaxScreen', 'components/ui/AddTaxScreen'],

    ['uiOpenListTaxValue', 'ListTaxValuesScreen', 'components/ui/ListTaxValuesScreen'],
    ['uiOpenAddTaxValue', 'AddTaxValueScreen', 'components/ui/AddTaxValueScreen'],
    ['uiOpenEditTaxValue', 'AddTaxValueScreen', 'components/ui/AddTaxValueScreen'],

    ['uiOpenListTaxProduct', 'ListTaxProductScreen', 'components/ui/ListTaxProductScreen'],
    ['uiOpenAddTaxProduct', 'AddTaxProductScreen', 'components/ui/AddTaxProductScreen'],
    ['uiOpenEditTaxProduct', 'AddTaxProductScreen', 'components/ui/AddTaxProductScreen'],

    ['uiOpenListMeasurementUnit', 'ListMeasurementUnit', 'components/ui/ListMeasurementUnit'],
    ['uiOpenAddMeasurementUnit', 'AddMeasurementUnit', 'components/ui/AddMeasurementUnit'],
    ['uiOpenEditMeasurementUnit', 'AddMeasurementUnit', 'components/ui/AddMeasurementUnit'],

    ['uiOpenListWarehouse', 'ListWarehouseScreen', 'components/ui/ListWarehouseScreen'],
    ['uiOpenAddWarehouse', 'AddWarehouseScreen', 'components/ui/AddWarehouseScreen'],
    ['uiOpenEditWarehouse', 'AddWarehouseScreen', 'components/ui/AddWarehouseScreen'],

    ['uiOpenListWarehouseGroup', 'ListWarehouseGroup', 'components/ui/ListWarehouseGroup'],
    ['uiOpenAddWarehouseGroup', 'AddWarehouseGroup', 'components/ui/AddWarehouseGroup'],
    ['uiOpenEditWarehouseGroup', 'AddWarehouseGroup', 'components/ui/AddWarehouseGroup'],
    ['uiOpenAssociateWarehouseGroupWarehouse', 'AssociateWarehouseGroupWarehouse', 'components/ui/AssociateWarehouseGroupWarehouse'],
    ['uiOpenAssociateWarehouseGroupDevice', 'AssociateWarehouseGroupDevice', 'components/ui/AssociateWarehouseGroupDevice'],

    ['uiOpenProductDetails', 'ListProductDetails', 'components/ui/ListProductDetails'],

    ['uiOpenListDgiiCert', 'ListDgiiCertScreen', 'components/ui/ListDgiiCertScreen'],
    ['uiOpenAddDgiiCert', 'AddDgiiCertScreen', 'components/ui/AddDgiiCertScreen'],
    ['uiOpenEditDgiiCert', 'EditDgiiCertScreen', 'components/ui/EditDgiiCertScreen'],

    ['uiOpenListProductHandlers', 'ListProductHandlersScreen', 'components/ui/ListProductHandlersScreen'],
    ['uiOpenEditProductHandler', 'AddOrEditProductHandler', 'components/ui/AddOrEditProductHandler'],
    ['uiOpenListProductHandlersGroup', 'ListProductHandlersGroupScreen', 'components/ui/ListProductHandlersGroupScreen'],
    ['uiOpenEditProductHandlerGroup', 'AddProductHandlerGroupScreen', 'components/ui/AddProductHandlerGroupScreen'],

];

export const screens = Object.fromEntries(
    defs.map(([key, named, path]) => [key, lazyNamed(() => import(`../${path}`), named)])
);
